import Close from '@mui/icons-material/Close'
import { CardContent, Divider } from '@mui/material'
import { Card, CardHeader, IconButton, Modal } from 'components'

import { useRejectReserveOrderLink } from 'modules/orders/hooks/useRejectReserveOrderLink'
import { ReasonForm } from 'modules/orders/components/ReasonForm'

type Props = {
  proposalId: string
  open: boolean
  onClose: () => void
  onRejected: () => void
}

export const RejectReserveOrderLinkModal = ({
  proposalId,
  open,
  onClose,
  onRejected
}: Props) => {
  const { mutate, isLoading } = useRejectReserveOrderLink({
    onSuccess: onRejected
  })

  const handleSubmit = ({
    conceptId,
    details
  }: {
    conceptId: string
    details?: string
  }) => {
    mutate({ proposalId, conceptId, details })
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      keepMounted={false}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <Card style={{ padding: 0, minWidth: 300, width: 600 }}>
        <CardHeader
          title={`Rejeitar Reserva — Orçamento n° ${proposalId}`}
          HeaderRight={
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          }
        />
        <Divider />
        <CardContent sx={{ maxHeight: 450, overflowY: 'auto' }}>
          <ReasonForm
            submitLabel="Rejeitar"
            isLoading={isLoading}
            onSubmit={handleSubmit}
            onCancel={onClose}
          />
        </CardContent>
      </Card>
    </Modal>
  )
}
